import script from "./SiteDisplayThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteDisplayThumb.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__